export const FRENCH_CODE_LIST = ['fr', 'fre', 'fra'];
export const MULTI_LANG = 'multi_langue';
